import React from 'react';
import ViewPackageComponent from '../../../Components/Package/ViewPackage';

export default function ViewPackage() {
    return (
        <div className='page-body'>
            <ViewPackageComponent />
        </div>
    );
}